const Bottle = () => {
  return (
    <div className="bottle">
      <svg
        x="0px"
        y="0px"
        width="32.339px"
        height="105.586px"
        viewBox="0 0 32.339 105.586"
        enableBackground="new 0 0 32.339 105.586"
        xmlSpace="preserve"
      >
        <defs>
          <pattern
            id="water_fill"
            width=".25"
            height="1.1"
            patternContentUnits="objectBoundingBox"
          >
            <path
              className="bottle-water"
              d="M0.25,1H0c0,0,0-0.659,0-0.916c0.083-0.303,0.158,0.334,0.25,0C0.25,0.327,0.25,1,0.25,1z"
            />
          </pattern>
          <path
            id="bottle_2"
            d="M30.836,48.086c-0.083-3.417-3.167-7.583-3.167-7.583s-3-15.5-4-19.667s-1.417-13.25-0.167-14.583
    s0-3.083-1.667-4.083s-5.667-0.583-5.667-0.583s-4-0.417-5.667,0.583S7.584,4.92,8.834,6.253S9.667,16.67,8.667,20.836
    s-4,19.667-4,19.667S1.584,44.67,1.5,48.086c-0.083,3.417,1.833,34.833,1.667,37.917C3,89.086,2.25,96.586,2.834,99.67
    c0.583,3.083,5.5,4.417,5.5,4.417h7.833H24c0,0,4.917-1.333,5.5-4.417c0.583-3.083-0.167-10.583-0.333-13.667
    C29.003,82.919,30.919,51.503,30.836,48.086z"
          />
          <mask id="bottle_mask_2">
            <use
              x="0"
              y="0"
              xlinkHref="#bottle_2"
              opacity="1"
              className="bottle-mask"
            />
          </mask>
        </defs>
        <rect
          className="bottle-fill"
          mask="url(#bottle_mask_2)"
          fill="url(#water_fill)"
          x="-400"
          y="0"
          width="1600"
          height="120"
        />
        <path
          id="btl-out"
          className="bottle-glass"
          fill="none"
          strokeWidth="3"
          strokeMiterlimit="10"
          d="M30.836,48.086
    c-0.083-3.417-3.167-7.583-3.167-7.583s-3-15.5-4-19.667s-1.417-13.25-0.167-14.583c1.25-1.333,0-3.083-1.667-4.083
    c-1.667-1-5.667-0.583-5.667-0.583s-4-0.417-5.667,0.583c-1.667,1-2.917,2.75-1.667,4.083c1.25,1.333,0.833,10.417-0.167,14.583
    s-4,19.667-4,19.667s-3.083,4.167-3.167,7.583c-0.083,3.417,1.833,34.833,1.667,37.917c-0.167,3.083-0.917,10.583-0.333,13.667
    c0.583,3.083,5.5,4.417,5.5,4.417h7.833h7.833c0,0,4.917-1.333,5.5-4.417c0.583-3.083-0.167-10.583-0.333-13.667
    C29.003,82.919,30.919,51.503,30.836,48.086z"
        />
      </svg>
    </div>
  );
};

export default Bottle;
